<header class="bg-background border-b border-border sticky top-0 z-10">
  <div class="mx-auto max-w-360 px-4 sm:px-6 lg:px-12">
    <div class="flex items-center justify-between h-15">

      <!-- Menu button — opens the navigation drawer below 1024px; from there the sidenav is a rail or full sidebar. -->
      @if (authService.isAuthenticated()) {
        <button
          #menuButton
          type="button"
          (click)="sidenavService.toggle(menuButton)"
          class="mr-3 rounded-pill p-2 min-h-11 min-w-11 flex items-center justify-center text-secondary hover:text-primary hover:bg-grey-100 transition-nike focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-focus lg:hidden"
          [attr.aria-expanded]="sidenavService.isOpen()"
          aria-label="Open navigation">
          <svg class="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        </button>
      }

      <!-- Logo -->
      <a
        routerLink="/"
        class="font-medium text-lg text-primary tracking-tight focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-focus">
        Sentinal Books
      </a>

      <!-- Company selector: in the header while the sidenav is a 72px rail (1024–1279px) -->
      @if (authService.isAuthenticated() && sidenavService.mode() === 'rail') {
        <div class="ml-auto mr-4 w-56">
          <app-company-dropdown />
        </div>
      }

      <!-- User info (only when authenticated) -->
      @if (authService.isAuthenticated()) {
        <button
          type="button"
          (click)="openAccountModal()"
          class="flex items-center gap-3 rounded-md p-1.5 -m-1.5 cursor-pointer transition-nike hover:bg-grey-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-focus"
          aria-haspopup="dialog"
          [attr.aria-expanded]="isAccountModalOpen()"
          aria-label="Account menu">

          <!-- Avatar -->
          <span
            class="h-8 w-8 shrink-0 rounded-pill bg-primary text-background flex items-center justify-center text-sm font-medium select-none"
            aria-hidden="true">
            {{ userInitials() }}
          </span>

          <!-- Name + email (from 768px) -->
          <span class="hidden md:flex flex-col items-start leading-tight" aria-hidden="true">
            <span class="text-caption font-medium text-primary">{{ displayName() }}</span>
            <span class="text-small text-secondary">{{ authService.userEmail() }}</span>
          </span>

        </button>
      }

    </div>
  </div>
</header>

@if (isAccountModalOpen()) {
  <app-modal title="Your account" (closed)="closeAccountModal()">
    <div class="mb-6 flex items-center gap-3">
      <div
        class="h-12 w-12 shrink-0 rounded-pill bg-primary text-background flex items-center justify-center text-body font-medium select-none"
        aria-hidden="true">
        {{ userInitials() }}
      </div>
      <div class="flex flex-col leading-tight">
        <span class="text-body font-medium text-primary">{{ displayName() }}</span>
        <span class="text-caption text-secondary">{{ authService.userEmail() }}</span>
      </div>
    </div>

    @if (userRoles().length > 0) {
      <div class="mb-6">
        <p class="mb-2 text-small font-medium uppercase tracking-wide text-secondary">Role(s)</p>
        <div class="flex flex-wrap gap-2">
          @for (role of userRoles(); track role) {
            <span class="inline-flex items-center rounded-pill bg-grey-100 px-3 py-1 text-small font-medium text-primary">{{ role }}</span>
          }
        </div>
      </div>
    }

    @if (userTenants().length > 0) {
      <div class="mb-6">
        <p class="mb-2 text-small font-medium uppercase tracking-wide text-secondary">Companies</p>
        <ul class="flex flex-col gap-2 p-0 m-0 list-none" role="list">
          @for (tenant of userTenants(); track tenant.id) {
            <li class="rounded-md border border-border bg-background px-4 py-2.5 text-body text-primary">
              {{ tenant.companyName }}
            </li>
          }
        </ul>
      </div>
    }

    <div class="border-t border-border pt-4">
      <app-button variant="secondary" [fullWidth]="true" (click)="logout()">Logout</app-button>
    </div>
  </app-modal>
}
